import { getAccessToken, getUserData } from "@/helper/localStorage";

export const isUserLoggedIn = () =>
  getAccessToken() !== '' && Object.keys(getUserData()).length > 0;
